
<div dwRow>
    <div dwCol="12">
        <label>Auto Complete After  <i class="fa fa-info-circle"
            title="Auto Completes the Timer after x minutes.  For Job Timers, this occurs x minutes past the Due Date/Date.  For Resource Timers, this occurs x minutes after the Start Time"></i></label>
        <input type="number" class="form-control" [(ngModel)]="config.autoCompleteAfterMinutes" (ngModelChange)="onChange()"
            dwNumeric>
    </div>
</div>
<div dwRow>
    <div dwCol="12">
        <b>Timer Colors <i class="fa fa-info-circle"
                title="Determine the tile color based on timer value.  Uses the first matching item"></i></b>
    </div>
</div>
<div dwRow>
    <div dwCol="3">
        <label>Min Value <i class="fa fa-info-circle" title="Optional min value in minutes for class to apply"></i></label>
    </div>

    <div dwCol="3">
        <label>Max Value <i class="fa fa-info-circle" title="Optional max value in minutes for class to apply"></i></label>
       
    </div>
    <div dwCol="4">
        <label>Color</label>     
    </div>
</div>
<ng-container *ngFor="let timerInterval of config?.timerIntervals; let i = index">
    <div dwRow>
        <div dwCol="3">
             <input type="number" class="form-control" [(ngModel)]="timerInterval.minTimerValueMinutes" (ngModelChange)="onChange()"
                dwNumeric>
        </div>

        <div dwCol="3">
            <input type="number" class="form-control" [(ngModel)]="timerInterval.maxTimerValueMinutes" (ngModelChange)="onChange()"
                dwNumeric>
        </div>
        <div dwCol="4">
            <select [(ngModel)]="timerInterval.cardClassKey" (ngModelChange)="onChange()" class="form-control">
                <option *ngFor="let item of cardClasses" [ngValue]="item.key">
                    {{item.display}}
                </option>
            </select>
        </div>
        <div dwCol="1">
            <i class="fa fa-times-circle dw-red pull-right" title="Remove Class" (click)="removeItem(timerInterval)"></i>
        </div>
    </div>
</ng-container>
<div dwRow>
    <div dwCol>
        <button class="btn-sm btn-success" (click)="addItem()">Add</button>
    </div>
</div>